import React from 'react';

interface NoDataProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  className?: string;
  containerClassName?: string;
}

const NoData: React.FC<NoDataProps> = ({
  title = "No Data Available",
  description = "No data found for the selected filters.",
  icon,
  className = "w-16 h-16 mx-auto mb-4 text-gray-300",
  containerClassName = "flex items-center justify-center h-full"
}) => {
  const defaultIcon = (
    <div className={className}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-full h-full"
      >
        <path d="M3 3v18h18" />
        <path d="M18.7 8l-5.1 5.2-2.8-2.7L7 14.3" />
      </svg>
    </div>
  );

  return (
    <div className={containerClassName}>
      <div className="text-center">
        {icon || defaultIcon}
        <h3 className="text-lg font-medium text-gray-500 mb-2">
          {title}
        </h3>
        <p className="text-sm text-gray-400">
          {description}
        </p>
      </div>
    </div>
  );
};

export default NoData;
